:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.subcategory-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(51, 51, 51, 0.15);
}

@media screen and (min-width: 980px) {
  .subcategory-list {
    max-width: 900px;
    min-width: 650px;
    min-height: 300px;
    box-sizing: border-box;
    border: 1px solid #e6e6e6;
    box-shadow: none;
  }
}